import { Component, Vue } from "vue-property-decorator";
import Template from "./overlay.template.vue";
@Component({
  mixins: [Template]
})
export default class OverlayComponent extends Vue {}
